import { themeColor } from '@/utils'
import { ThemeColor } from '@/enums'

import { AdaptiveTooltip } from '@surein/ui'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const WhyDoWeAskButtonWrapper = styled.div`
  width: fit-content;
  cursor: pointer;
`

const WhyDoWeAskWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  color: ${themeColor(ThemeColor.info1)};
  text-decoration: underline;
`

export const WhyDoWeAsk = () => {
  const { t } = useTranslation()

  return (
    <WhyDoWeAskButtonWrapper>
      <AdaptiveTooltip
        content={t('selfAssessment.locationType.explanationText')}
      >
        <WhyDoWeAskWrapper>
          {t('selfAssessment.locationType.explanationButtonLabel')}
        </WhyDoWeAskWrapper>
      </AdaptiveTooltip>
    </WhyDoWeAskButtonWrapper>
  )
}
